<template>
   <form @submit.prevent="validate('userid')"
       data-vv-scope="userid"
       class="col-12 col-lg-4 account__userdata__col">
      <div class="account__block__title mb-3">{{ t('user.page.data.personal') }}</div>
      <form-message :messages="getMessage( 'userid')"></form-message>
      <div class="row">
         <div class="col-12">
            <label class="account__block__label">
               {{ t('page.user.data.name') }}
            </label>
            {{ user.firstname }} <span>{{ user.lastname }}</span>
         </div>
      </div>
      <hr class="account__block__hr">
      <div class="row">
         <div class="col-12">
            <label class="account__block__label">
               {{ t('page.user.data.birthday') }}
            </label>
            {{ birthday }}
         </div>
      </div>
      <hr class="account__block__hr">
      <div class="row">
         <vee-input
             v-model="form.cin.phone"
             class="col-12 required"
             scope="userid"
             name="phone"
             :spellcheck="false"
             :data-vv-as="t('field.phone')"
             v-validate="phoneValidate"
             id="userdata__phone"
             :placeholder="user.phone ? user.phone : ''"
         >
								<span slot="label" class="account__block__label">
									{{ t('page.user.data.phone') }}
								</span>
         </vee-input>
         <!--<div class="col-12">
           <label class="account__block__label">
             {{t('page.user.data.phone')}}
           </label>
           {{ user.phone }}
         </div>-->
      </div>
      <hr class="account__block__hr">
      <div v-if="isProvisional">
         <div class="row">
            <div class="col-12 account__block__label d-flex align-items-start flex-wrap">
               {{ t('page.user.data.id.upload') }}


               <div class="account__userdata__id__files">
                  <div class="custom-file register__file userdata__file_id ml-2" v-if="changeAvailable">
                     <!--File 1-->
                     <input type="file" @change="processFile($event, form.cin, 'file')"
                         v-validate="idValidate"
                         multiple
                         :disabled="user.identity_upload_status"
                         name="cinFile"
                         class="custom-file-input"
                         id="userdata__id-photo"
                         accept="image/*,application/pdf"
                         :data-vv-as="t('field.id.image')">
                     <label class="custom-file-label" for="userdata__id-photo">
                        <span v-if="!form.cin.file.length">{{ t('user.page.userdata.id.upload.hint') }}</span>
                        <div :style="'background-image: url('+getFileIcon(cimi.src)+');'"
                            v-for="(cimi, index) in form.cin.file"
                            :key="'id-file_'+index"
                            class="register__img-preview">
                        </div>
                     </label>
                  </div>
                  <!--File 2-->
                  <div
                      class="custom-file register__file userdata__file_id mt-2"
                      v-if="settings.use_two_cin_files && changeAvailable && (user.identity_upload_status || form.cin.file.length > 0)"
                  >
                     <input type="file" @change="processFile($event, form.cin, 'file2')"
                         v-validate="idValidate"
                         multiple
                         :disabled="user.identity_upload_2_status"
                         name="cinFile2"
                         class="custom-file-input"
                         id="userdata__id-photo2"
                         accept="image/*,application/pdf"
                         :data-vv-as="t('field.id.image2')">
                     <label class="custom-file-label" for="userdata__id-photo2">
                        <span v-if="!form.cin.file2.length">{{ t('user.page.userdata.id.upload.hint') }}</span>
                        <div :style="'background-image: url('+getFileIcon(cimi.src)+');'"
                            v-for="(cimi, index) in form.cin.file2"
                            :key="'id-file_'+index"
                            class="register__img-preview">
                        </div>
                     </label>
                  </div>
               </div>

               <!--Errors-->
               <div v-if="isInValid('userid.cinFile')"
                   class="invalid-feedback"
                   :class="{ 'd-block': isInValid('userid.cinFile') }">
                  {{ errors.first('userid.cinFile') }}
               </div>
               <div v-if="isInValid('userid.cinFile2')"
                   class="invalid-feedback"
                   :class="{ 'd-block': isInValid('userid.cinFile2') }">
                  {{ errors.first('userid.cinFile2') }}
               </div>
               <div class="valid-feedback d-block" v-if="user.identity_upload_status">
                  <t tag="page.user.data.id.uploaded"></t>
               </div>
               <div class="valid-feedback d-block" v-if="settings.use_two_cin_files && user.identity_upload_2_status">
                  <t tag="page.user.data.id2.uploaded"></t>
               </div>
               <div class="valid-feedback d-block" v-if="user.image_upload_completed">
                  <t tag="page.user.data.id.finished"></t>
               </div>
               <div class="valid-feedback d-block" v-if="user.identitystatus">
                  <t tag="page.user.data.id.validated"></t>
               </div>


            </div>
         </div>
         <hr class="account__block__hr">

      </div>
      <div class="row mt-4" v-if="isSubmit('userid')|| form.cin.file.length > 0 || form.cin.phone !== ''">
         <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-primary btn-sm" type="submit">
               {{ t('general.btn.submit') }}
            </button>
         </div>
      </div>


   </form>
</template>

<script>
import moment from 'moment-timezone';
import VeeInput from '@/components/ValidateInput';
import FormMessage from '@/components/parts/form-message';
import Vuex from 'vuex';
import {mixins} from "@/components/user/UserData/user_helpers";
import _ from "lodash";


export default {
   name: "personal_data",
   components: {
      VeeInput,
      FormMessage,

   },

   mixins:[mixins],
   data() {
      return {

         loading: [],

         settings:{
           use_two_cin_files: true //PMCLNL-466
         },

         form: {
            cin: {
               file: [],
               file2: [],
               phone: ''
            },
         }
      }
   },
   computed:{
      ...Vuex.mapState([
         'lang',
         'loaderList'
      ]),
      ...Vuex.mapGetters({
         user: 'getUser',
         userLogedIn: 'getUserStatus',
         details: 'getUserDetails'
      }),
      birthday() {
         return moment(this.user.birthdate).format('DD MMMM YYYY')
      },
      idValidate() {

         return {
            required: false,
            ext: ['jpg', 'png', 'bmp', 'svg', 'pdf']
         }
      },
      isProvisional(){
         return this.user['customerstatus_id'] === 0;
      },
      changeAvailable() {
         return this.isProvisional && !this.user.image_upload_completed && (!this.user.identity_upload_status || (!this.settings.use_two_cin_files || !this.user.identity_upload_2_status) );
      },
      phoneValidate() {

         return {
            required: this.form.cin.phone !== '',
            numeric: true,
            max: 20
         };
      },
   },
   methods:{
      validate(scope) {
         this.$validator.validateAll(scope).then((result) => {

            if (result) {
               this.deleteMessage(scope);
               this.updateId();
            }


         });
      },
      //Update user id photo
      updateId() {


         let data = {};

         if (this.form.cin.file.length > 0 && this.changeAvailable) {
            data['id_card_image'] = this.form.cin.file;
         }
         if (this.settings.use_two_cin_files && this.form.cin.file2.length > 0 && this.changeAvailable) {
            data['id_card_image_2'] = this.form.cin.file2;
         }

         if (this.form.cin.phone !== '') {
            data['phone'] = this.form.cin.phone;
         }

         if (!_.isEmpty(data)) {
            //Show loading bar
            this.$store.commit('addLoad', 'userid');
         } else {
            return;
         }

         //Push to vuex new data values to send it to REST
         this.$store.dispatch('saveUserData', data).then((responce) => {

            //Finish load bar
            this.$store.commit('endLoad', 'userid');

            //Error handling
            if (responce.data.status === 'SUCCESS') {

               //Show message that all successfully changed
               this.addMessage({
                  scope: 'userid',
                  state: 'success',
                  text: this.t('user.data.id.change.success')
               });

               this.form.cin.file = [];
               this.form.cin.file2 = [];
               setTimeout(() => {
                  this.errors.clear('userid');
               }, 50);
            } else {
               //Show message that some error has occurred
               let msg = '';

               if (typeof responce.data.error !== 'undefined') {
                  if (Array.isArray(responce.data.error)) {
                     msg = this.t('userdata.error.' + responce.data.error[0].property + '.' + responce.data.error[0].code);
                  } else {
                     msg = this.t('userdata.error.' + responce.data.error.code);
                  }
               } else {
                  msg = responce.data.message
               }

               this.addMessage({
                  scope: 'userid',
                  state: 'danger',
                  text: msg
               });
            }

         });

      },
   }
}
</script>

<style scoped>

</style>
